@if (audioClient) {
	<div class="notificationContainer">
		<div class="notificationContentContainer">
			<div class="notificationHeader">
				<i class="fad fa-microphone headerIcon"></i>
				<div class="text mat-h2 nomargin">
					{{ T.GLOBAL_TEXT_MICROPHONES | translate }}
				</div>
				<button
					(click)="closeComponent.emit()"
					class="closeNotificationButton"
					color="warn"
					mat-icon-button
				>
					<mat-icon
						fontIcon="fa-times"
						fontSet="fas"
						inline
						style="font-size: 0.9em"
					/>
				</button>
			</div>

			<mat-divider class="notificationContainerDivider" />
			<canvas
				[hidden]="!audioClient.connected() || !audioClient.supportsVisualizer"
				#levelMeter
				height="50px"
			></canvas>
			@if (audioClient.supportsVolumeControl) {
				<div>
					<mat-slider
						[min]="0"
						[max]="100"
						[step]="1"
						discrete
						style="width: 80%"
						color="accent"
					>
						<input
							matSliderThumb
							[value]="audioClient.volume() * 100"
							(valueChange)="audioClient.volume.set(+$event / 100)"
						/>
					</mat-slider>
					<div class="actions">
						<button
							color="accent"
							mat-icon-button
							matTooltipClass="accent"
							matTooltip="{{ T.AUDIO_INPUT_DEVICE_BUTTON_SHOW_MUTE | translate }}"
							(click)="audioClient.muted.set(!audioClient.muted())"
							[class.on]="audioClient.muted()"
						>
							<mat-icon
								fontSet="fa"
								[fontIcon]="audioClient.muted() ? 'fa-microphone-slash' : 'fa-microphone'"
								inline
							/>
						</button>
					</div>
				</div>
			}
			<div class="audioServerClass">
				@if (audioClient.connected()) {
					<table>
						@for (audioDevice of audioClient.audioDevices?.(); track audioDevice) {
							<tr>
								<td>
									<div
										(click)="setAudioDevice(audioDevice)"
										class="allIconDesign"
									>
										<i
											[ngClass]="{
												activeIcon: audioDevice.isSameAs(audioClient.selectedAudioDevice()),
											}"
											class="fad fa-microphone audioIconPosition"
										></i>
										<div class="allAudioNamesDesign">
											{{ audioDevice.label }}
										</div>
									</div>
								</td>
							</tr>
						}
					</table>
				}
				@if (!audioClient.connected()) {
					<div>
						{{ T.COULD_NOT_ACCESS_TO_SIM_MICROPHONES | translate }}
					</div>
				}
			</div>
		</div>
	</div>
}
